<template>
  <WorkingAreaQuickView
    :title-key="titleKey"
    :subtitle="subtitle"
    :items="items"
    :empty-text="emptyText || $t('no_rooms_found')"
    @close="$emit('close')"
  />
</template>

<script>
import WorkingAreaQuickView from './WorkingAreaQuickView.vue'

export default {
  props: {
    titleKey: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: '',
    },
  },
  components: { WorkingAreaQuickView },
}
</script>
